import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const AUTOMATIONS_URL = getBaseUrl('/automations/');

export async function getAutomations(page, environment, size, strategyId, market, onlyActive, standalone) {
    const params = { page: page || 1 };
    if (environment) params.environment = environment;
    if (size) params.size = size;
    if (strategyId) params.strategyId = strategyId;
    if (market) params.market = market;
    if (onlyActive) params.onlyActive = 'true';
    if (standalone) params.standalone = 'true';
    return await appRequest.doGetRequest(`${AUTOMATIONS_URL}?${new URLSearchParams(params).toString()}`);  // { count, rows }
}

export async function getAutomationsBySymbol(symbol, environment) {
    const params = { symbol };
    if (environment) params.environment = environment;
    return await appRequest.doGetRequest(`${AUTOMATIONS_URL}?${new URLSearchParams(params).toString()}`);
}

export async function getAutomationsCounts(market) {
    const qs = market ? `?market=${market}` : '';
    return await appRequest.doGetRequest(`${AUTOMATIONS_URL}counts${qs}`);
}

export async function getAllAutomations(symbol, quote, onlyActives, environment) {
    const params = {};
    if (symbol) params.symbol = symbol;
    if (quote) params.quote = quote;
    if (onlyActives) params.onlyActives = onlyActives;
    if (environment) params.environment = environment;

    const requestParams = new URLSearchParams(params).toString();

    return await appRequest.doGetRequest(`${AUTOMATIONS_URL}all/?${requestParams}`);
}

export async function saveAutomation(id, newAutomation) {
    if (id)
        return await appRequest.doPatchRequest(`${AUTOMATIONS_URL}${id}`, newAutomation);
    else
        return await appRequest.doPostRequest(AUTOMATIONS_URL, newAutomation);
}

export async function saveGrid(id, newAutomation, levels, quantity) {
    const gridParameters = `?levels=${levels}&quantity=${quantity}`;
    if (id)
        return await appRequest.doPatchRequest(`${AUTOMATIONS_URL}${id}${gridParameters}`, newAutomation);
    else
        return await appRequest.doPostRequest(`${AUTOMATIONS_URL}${gridParameters}`, newAutomation);
}

export async function startAutomation(id) {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}${id}/start`, {});
}

export async function stopAutomation(id) {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}${id}/stop`, {});
}

export async function promoteAutomation(id) {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}${id}/promote`, {});
}

export async function copyAutomationToTest(id) {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}${id}/copyToTest`, {});
}

export async function copyAllAutomationsToTest() {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}copyAllToTest`, {});
}

export async function createMissingAutomations(symbol = 'BTCUSDT') {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}createMissing`, { symbol });
}

export async function runAutomation(id) {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}${id}/run`, {});
}

export async function deleteAutomation(id) {    
    return await appRequest.doDeleteRequest(`${AUTOMATIONS_URL}${id}`);
}

export async function activateByActionType(actionType) {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}activateByType`, { actionType });
}

export async function activateSupportingAutomations() {
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}activateSupporting`, {});
}

export async function doBacktest(newBacktest) {
    const payload = { ...newBacktest };
    delete payload.results;
    payload.startTime = new Date(payload.startTime).getTime();
    payload.endTime = new Date(payload.endTime).getTime();
    return await appRequest.doPostRequest(`${AUTOMATIONS_URL}backtest`, payload);
}
